export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover o dependente <b>${this.currentEntity.name}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/dependents/resources/computed.js